module.exports = __webpack_public_path__ + "static/img/SupervisionLogo.97d1c723.png";